var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.75H12.7812L12.5469 22.7344C12.4531 23.1562 12.4531 23.625 12.5938 24H3.5C1.8125 24 0.5 22.6875 0.5 21V3C0.5 1.35938 1.8125 0 3.5 0H11.2344C12.0312 0 12.7812 0.328125 13.3438 0.890625L17.6094 5.15625C18.1719 5.71875 18.5 6.46875 18.5 7.26562V13.4062L16.25 15.6562V7.5H12.5C11.6562 7.5 11 6.84375 11 6V2.25H3.5C3.07812 2.25 2.75 2.625 2.75 3V21C2.75 21.4219 3.07812 21.75 3.5 21.75ZM26.2344 11.0625L26.9375 11.7656C27.6406 12.4688 27.6406 13.6406 26.9375 14.3906L25.5312 15.7969L22.2031 12.4688L23.6094 11.0625C24.3125 10.3594 25.5312 10.3594 26.2344 11.0625ZM15.0781 19.5469L21.1719 13.5L24.5 16.8281L18.4062 22.875C18.2188 23.0625 17.9844 23.2031 17.75 23.2969L14.8906 24C14.6562 24.0469 14.375 24 14.1875 23.8125C14 23.625 13.9531 23.3438 14 23.0625L14.7031 20.25C14.75 20.0156 14.8906 19.7344 15.0781 19.5469Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOn);
export default __webpack_public_path__ + "static/media/editOn.0489952413f1823556b94f4669d94075.svg";
export { ForwardRef as ReactComponent };